<template>
  <PopUp v-if="isSetupStripePopupVisible">
    <div class="stripe-setup-popup">
      <img
        src="@/assets/icons/stripe.svg"
        alt="Stripe icon"
        class="stripe-setup-popup__icon"
      >
      <div class="stripe-setup-popup__text">
        To start receiving payments you need to setup your Stripe integration
      </div>
      <button
        type="button"
        class="ftn-btn stripe-setup-popup__setup-button"
        @click="handleOnConfirmButtonClick"
      >
        Setup Stripe integration
      </button>
      <button
        type="button"
        class="stripe-setup-popup__skip-button"
        aria-label="Skip setup"
        @click="handleOnCancelButtonClick"
      >
        Skip for now
      </button>
    </div>
  </PopUp>
</template>

<script>
import { mapGetters } from 'vuex';
import PopUp from '@/components/PopUp';

export default {
  name: 'SetupStripePopup',
  components: { PopUp },
  computed: {
    ...mapGetters({
      isSetupStripePopupVisible: 'isSetupStripePopupVisible',
      setupStripePopupHandlers: 'setupStripePopupHandlers',
    }),
  },
  methods: {
    async handleOnCancelButtonClick() {
      await this.setupStripePopupHandlers.handleOnPopupClose();
    },
    async handleOnConfirmButtonClick() {
      await this.setupStripePopupHandlers.handleOnPopupSuccess();
    },
  },
};
</script>

<style
  scoped
  lang="scss"
>
@import "~@/assets/scss/mixins";

.stripe-setup-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;

  @include media-lg() {
    padding: 96px;
  }

  &__icon {
    margin-bottom: 32px;

    width: 40px;
    height: 40px;
  }

  &__text {
    margin-bottom: 32px;
    max-width: 368px;

    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    text-align: center;
  }

  &__setup-button {
    margin-bottom: 16px;
  }

  &__skip-button {
    font-size: 15px;
    line-height: 24px;

    background: none;
    color: var(--gray-3);
    text-decoration: underline;
  }
}
</style>
